import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { withTrackedSceneView } from '@ihme/common/packages/google-analytics';

import Layout from '../components/Layout';
import HomeScene from '../components/HomeScene';
import GlobalImpactScene from '../components/GlobalImpactScene';
import TrendsScene from '../components/TrendsScene';
import BreakdownScene from '../components/BreakdownScene';
import FactsheetsScene from '../components/FactsheetsScene';
import AboutScene from '../components/AboutScene';

import {
    ABOUT_PATH,
    HOME_PATH,
    GLOBAL_IMPACT_PATH,
    TRENDS_PATH,
    BREAKDOWN_PATH,
    FACTSHEETS_PATH,
} from './paths';

const LayoutRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props => (
            <Layout>
                <Component {...props} />
            </Layout>
        )}
    />
);

export default () => (
    <Router>
        <div>
            <Route path={HOME_PATH} exact component={withTrackedSceneView(HomeScene)} />
            <LayoutRoute
                path={GLOBAL_IMPACT_PATH}
                exact
                component={withTrackedSceneView(GlobalImpactScene)}
            />
            <LayoutRoute path={TRENDS_PATH} exact component={withTrackedSceneView(TrendsScene)} />
            <LayoutRoute
                path={BREAKDOWN_PATH}
                exact
                component={withTrackedSceneView(BreakdownScene)}
            />
            <LayoutRoute
                path={FACTSHEETS_PATH}
                exact
                component={withTrackedSceneView(FactsheetsScene)}
            />
            <LayoutRoute path={ABOUT_PATH} exact component={withTrackedSceneView(AboutScene)} />
        </div>
    </Router>
);
